<div class="titles-wrapper">
  <div class="title-container">
    <div class="selector-div-wrapper">
      <p><small>Mostrar</small></p>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="popup-switch"
          [(ngModel)]="tool.enabled" [checked]="tool.enabled" />
      </div>
    </div>
  </div>
  <div class="title-container" *ngIf="tool.enabled">
    <div class="selector-div-wrapper">
      <p>Imagen</p>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="popup-image-switch"
          [(ngModel)]="tool.image" [checked]="tool.image" />
      </div>
    </div>
    <div class="color-selector-row mt-2">
      <div>
        <p class="me-3">Background:</p>
      </div>
      <div>
        <input class="colorpicker-input" [(ngModel)]="colors.background" [value]="colors.background"
          [style.background]="colors.background" [(colorPicker)]="colors.background" />
      </div>
    </div>
    <div class="color-selector-row mt-2">
      <div>
        <p class="me-3">Label:</p>
      </div>
      <div>
        <input class="colorpicker-input" [(ngModel)]="colors.tag" [value]="colors.tag" [style.background]="colors.tag"
          [(colorPicker)]="colors.tag" />
      </div>
    </div>
    <div class="color-selector-row mt-2">
      <div>
        <p class="me-3">Valores:</p>
      </div>
      <div>
        <input class="colorpicker-input" [(ngModel)]="colors.value" [value]="colors.value"
          [style.background]="colors.value" [(colorPicker)]="colors.value" />
      </div>
    </div>
    <div class="color-selector-row mt-2">
      <div>
        <p>Información personalizada:</p>
      </div>
    </div>
    <div class="upload-file-container">
      <div class="file-content" *ngIf="!tool.data; else fileExisting" (fileDrop)="onFileDropped($event)" fileDropZone>
        <p class="text-drag-file">Arrastrar fichero JSON aquí</p>
        <p class="text-drag-file divisor">— o —</p>
        <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
        <button class="upload-file-btn" (click)="fileUpload.click()">
          Seleccionar un fichero de tu ordenador
        </button>
      </div>
      <div class="text-end">
        <a class="btn-transparent" [href]="downloadTemplate" download="popups_template.json">Descargar plantilla</a>
      </div>
    </div>
    <ng-template #fileExisting>
      <div class="file-content">
        <div class="file-box">
          <p>{{ filename }}</p>
          <button class="element-action-btn" (click)="deleteDroppedFile()">
            <img id="delete" alt="" />
          </button>
        </div>
        <div class="json-wrapper">
          <ngx-json-viewer *ngIf="tool.data" [json]="tool.data" [expanded]="false"></ngx-json-viewer>
        </div>
      </div>
    </ng-template>
  </div>
</div>